// import { initialState } from "./gameContext";
import {
  SETUP_GAME_SETTINGS,
  UPDATE_PLAYERS_BIDS,
  RESET_PLAYER_BIDS,
  SUBMIT_WINNING_BID,
  RESET_WINNING_BID,
  SET_TRUMP_SUIT,
  SET_CURRENT_TURN,
  UPDATE_CURRENT_TRICK,
  SET_TRICK_LEADER,
  SET_TRICK_SUIT,
  AWARD_TRICK_TO_WINNER,
  AWARD_TRICK_TO_PLAYER,
  RESET_CURRENT_TRICK,
  RESET_TRICK_SUIT,
  RESET_BIDDING_ROUND,
  UPDATE_SCORE,
  UPDATE_INDIVIDUAL_SCORES,
  RESET_CURRENT_TURN,
  RESET_GAME_SETTINGS,
  PLAY_AGAIN_SAME_SETTINGS,
  SHOW_TRICK_CARD_WINNER,
} from "./gameActions";
import { initialState } from "./gameContext";
import { generateBotNames } from "../../utils/botNames";

const gameReducer = (state, action) => {
  if (action.type === SETUP_GAME_SETTINGS) {
    return {
      ...state,
      numPlayers: action.payload.numPlayers,
      username: action.payload.username,
      gameMode: action.payload.gameMode,
      winningScore: action.payload.winningScore,
      botNames: generateBotNames(),
      settingsSubmitted: true,
    };
  }
  if (action.type === UPDATE_PLAYERS_BIDS) {
    return {
      ...state,
      playerBids: {
        ...state.playerBids,
        [action.payload.player]: action.payload.bidAmount,
      },
    };
  }
  if (action.type === RESET_PLAYER_BIDS) {
    return {
      ...state,
      playerBids: { p1bid: null, p2bid: null, p3bid: null, p4bid: null },
    };
  }
  if (action.type === SUBMIT_WINNING_BID) {
    return {
      ...state,
      winningBid: {
        ...state.winningBid,
        bid: action.payload.bid,
        player: action.payload.player,
        team: action.payload.team,
      },
      leader: action.payload.player,
    };
  }
  if (action.type === RESET_WINNING_BID) {
    return {
      ...state,
      winningBid: { bid: 0, team: "", player: "", success: false },
    };
  }
  if (action.type === SET_TRUMP_SUIT) {
    // trickSuit intentionally left alone here (should still be "" from the
    // fresh deal) - it used to get set to the trump suit itself, which made
    // playCard()'s "has anyone led yet" check (trickSuit === "") always
    // false, so the very first trick of every hand incorrectly treated
    // trump as though it had already been led before anyone had.
    return {
      ...state,
      trump: action.payload.trump,
    };
  }
  if (action.type === SET_CURRENT_TURN) {
    return {
      ...state,
      currentTurn: action.payload.player,
    };
  }
  if (action.type === UPDATE_CURRENT_TRICK) {
    return {
      ...state,
      currentTrick: [...state.currentTrick, action.payload.card],
    };
  }
  if (action.type === SHOW_TRICK_CARD_WINNER) {
    return {
      ...state,
      currentTrick: action.payload.updatedTrick,
    };
  }
  if (action.type === RESET_CURRENT_TRICK) {
    return {
      ...state,
      currentTrick: [],
    };
  }
  if (action.type === SET_TRICK_LEADER) {
    return {
      ...state,
      leader: action.payload.player,
    };
  }
  if (action.type === SET_TRICK_SUIT) {
    return {
      ...state,
      trickSuit: action.payload.suit,
    };
  }
  if (action.type === AWARD_TRICK_TO_WINNER) {
    return {
      ...state,
      wonTricks: {
        ...state.wonTricks,
        [action.payload.team]: [
          ...state.wonTricks[action.payload.team],
          ...action.payload.trick,
        ],
      },
    };
  }
  if (action.type === AWARD_TRICK_TO_PLAYER) {
    return {
      ...state,
      wonTricksByPlayer: {
        ...state.wonTricksByPlayer,
        [action.payload.player]: [
          ...state.wonTricksByPlayer[action.payload.player],
          ...action.payload.trick,
        ],
      },
    };
  }
  if (action.type === RESET_TRICK_SUIT) {
    return {
      ...state,
      trickSuit: "",
    };
  }
  if (action.type === UPDATE_SCORE) {
    return {
      ...state,
      teamAScore: action.payload.teamA,
      teamBScore: action.payload.teamB,
      points: action.payload.points,
      winningBid: { ...state.winningBid, success: action.payload.success },
    };
  }
  if (action.type === UPDATE_INDIVIDUAL_SCORES) {
    return {
      ...state,
      individualScores: action.payload.scores,
      individualPoints: action.payload.points,
      winningBid: { ...state.winningBid, success: action.payload.success },
    };
  }
  if (action.type === RESET_BIDDING_ROUND) {
    return {
      ...state,

      points: initialState.points,
      winningBid: initialState.winningBid,
      trump: initialState.trump,
      leader: initialState.leader,
      trickSuit: initialState.trickSuit,
      wonTricks: initialState.wonTricks,
      individualPoints: initialState.individualPoints,
      wonTricksByPlayer: initialState.wonTricksByPlayer,
    };
  }
  if (action.type === RESET_CURRENT_TURN) {
    return {
      ...state,
      currentTurn: "",
    };
  }
  if (action.type === RESET_GAME_SETTINGS) {
    return {
      ...initialState,
    };
  }
  if (action.type === PLAY_AGAIN_SAME_SETTINGS) {
    return {
      ...state,
      points: initialState.points,
      winningBid: initialState.winningBid,
      trump: initialState.trump,
      leader: initialState.leader,
      trickSuit: initialState.trickSuit,
      wonTricks: initialState.wonTricks,
      teamAScore: initialState.teamAScore,
      teamBScore: initialState.teamBScore,
      individualPoints: initialState.individualPoints,
      wonTricksByPlayer: initialState.wonTricksByPlayer,
      individualScores: initialState.individualScores,
      currentTrick: initialState.currentTrick,
      currentTurn: initialState.currentTurn,
    };
  }

  throw new Error(`no such action: ${action.type}`);
};

export default gameReducer;
